import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { Store } from '../../../../utils/storage/keys'
import { IdentityScreen } from '../../enums'

export class PasswordlessEmailSent {
    private static DOM = {
        class: {
            passwordlessEmail: 'passwordless-email',
            passwordlessEmailSentPage: 'page-passwordless-email-sent'
        }
    }

    /**
     * Add the email address to page copy and remove loader
     */
    public init() {
        const passwordlessEmailSentPage = document.querySelector(
            `.${PasswordlessEmailSent.DOM.class.passwordlessEmailSentPage}`)
        if (passwordlessEmailSentPage) {
            if (sessionStorage) {
                const email = sessionStorage.getItem(Store.PASSWORDLESS_EMAIL_ADDRESS)
                const passwordlessEmailDOM = document.querySelector(
                    `.${PasswordlessEmailSent.DOM.class.passwordlessEmail}`)

                if (passwordlessEmailDOM) {
                    passwordlessEmailDOM.innerHTML = email
                }
            }
            DOMUtils.addClass(document.body, IdentityScreen.FORM)
            logger('debug', 'Passwordless email sent page loaded')
        }
    }
}
